/*
  Sección "Clean Image Slider" (sections/Infinite-image-gallery.liquid).

  Reemplaza a window.initImageSlider, que antes llegaba dentro del bundle del
  proveedor y ya no existe. Sin ella, el script de la sección se quedaba
  reintentando cada 100 ms indefinidamente y llenaba la consola.

  El desplazamiento lo hace el CSS: .slider-group tiene
  `animation: scroll-x var(--scroll-speed, 25s) linear infinite`, y el Liquid ya
  imprime dos .slider-group idénticos, que es lo que hace la marquesina continua.
  Aquí solo se prepara lo que el CSS necesita y el Liquid no genera.
*/
(function () {
  // El Liquid escribe `--scroll-speed: {{ section.settings.speed }}`. El ajuste
  // actual guarda valores con unidad ("8s", "14s", "20s"), pero pueden quedar
  // valores numéricos antiguos ("3"). Un número sin unidad invalida la
  // declaración `animation` completa y la marquesina se queda quieta.
  function normalizeSpeed(wrapper) {
    var raw = (getComputedStyle(wrapper).getPropertyValue('--scroll-speed') || '').trim();
    if (raw && /^\d+(\.\d+)?$/.test(raw)) {
      wrapper.style.setProperty('--scroll-speed', raw + 's');
    }
  }

  window.initImageSlider = function (sectionId) {
    var wrapper = document.getElementById(sectionId);
    if (!wrapper) return;

    var groups = wrapper.querySelectorAll('.image-slider .slider-group');
    if (!groups.length) return;

    normalizeSpeed(wrapper);

    // .slider-image aporta width/flex-shrink; sin ella las imágenes se estiran.
    groups.forEach(function (group) {
      group.querySelectorAll('img').forEach(function (img) {
        img.classList.add('slider-image');
        img.setAttribute('draggable', 'false');
      });
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      groups.forEach(function (group) {
        group.style.animation = 'none';
      });
    }
  };
})();
